import {useEffect} from 'react';
import analytics from 'shared/utility/analytics';
import {useLocation} from "react-router-dom";

export const useTrackPageview = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    if (pathname) {
      analytics.sendPageview(pathname)
    }
  }, [pathname]);
}

export default useTrackPageview;
